(() => {
	const scrollbarWidth = window.innerWidth - document.body.clientWidth;
	document.body.style.setProperty('--scrollbarWidth', `${scrollbarWidth}px`);
	window.dispatchEvent(new Event('resize'));
})();
